export default "__VITE_ASSET__zYZ6JaPw__"